//#region  import
import React, { Component } from "react"
import { CATEGORY } from "../../modules/constants"
import { createNexusHeadersData } from "../../tableData/nexus/createNexusHeadersData"
import { createNexusRowData } from "../../tableData/nexus/createNexusRowData_new"
import { createNexusFootersData } from "../../tableData/nexus/createNexusFootersData"
import NumerableTable from "../NumerableTable"
import initStats from "../../components/layout/InitStats"
import NoDataMessage from "../searchCompanies/NoDataMessage"

//#endregion import

class NexusTable extends Component {
  /*
  shouldComponentUpdate(nextProps, nextState) {
    // console.log("this.props.searchResults:",this.props.searchResults)
    // console.log("nextProps.searchResults:",nextProps.searchResults)
    return nextProps.searchString !== this.props.searchString || nextProps.searchResults !== this.props.searchResults
  }
  */

  render() {
    // console.log("NexusTable this.props: ", this.props)
    const { connections, handleClickFavouriteIcon, handleSelect, items, kind, lsePerson, showIndex, tabIndex, tableAnalysis } = this.props
    const isCompany = items[0].entity.category === CATEGORY.COMPANY
    const parentName = items[0].entity.name.toPresent ?? items[0].entity.name.original
    const lseCompany = !!items[0].entity.companyProps?.lse
    const stats = initStats()
    const tableProps = { ...this.props, isCompany, lseCompany, parentName, showIndex, stats }

    return (
      <React.Fragment>
        {items?.length < 2 &&
          <NoDataMessage totalResults={Object.keys(connections).length} kind={kind} lseCompany={lseCompany} lsePerson={lsePerson} tabIndex={tabIndex} />}

        {items.length > 1 &&
          (<NumerableTable table={{
            ...this.props,
            headers: createNexusHeadersData(tableProps),
            rows: createNexusRowData(tableProps),
            footers: tableAnalysis ? createNexusFootersData(tableProps) : null,
            handleOnClick: row => handleSelect(row.link),
            handleClickFavouriteIcon: row => handleClickFavouriteIcon(row),
          }}
          ></NumerableTable>)
        }
      </React.Fragment>
    )
  }
}

export default NexusTable